module.exports = __webpack_public_path__ + "img/recommendations-image.2bd76722.jpg";